import React, { useEffect, useState, useMemo, useRef, useImperativeHandle } from "react";
import { toast } from 'react-toastify';
import Modal from "react-modal";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import Spinner from "../../common/Spinner/Spinner";
import { Button } from "../../common/Button/Button";
import api from "../../utils/api";
import FTULandingPageVehicleData from "./FTULandingPageVehicleData";

const DreamBigProgramManagerLandingPageTable = (props) => {
  const [rowData, setRowData] = useState([]);
  const [resourcesData, setResourcesData] = useState([]);
  const [sortBy, setSortBy] = useState('');
  const [ftuVehicleQuestionCount, setFtuVehicleQuestionCount] = useState([])
  const [ftuDeviceCount, setFtuDeviceCount] = useState([])
  const [vehicleDeviceCombination, setVehicleDeviceCombination] = useState([]);
  const [vehicleDeviceCombinationFilterData, setVehicleDeviceCombinationFilterData] = useState([]);
  const [vehicleOptions, setVehicleOptions] = useState([])
  const [deviceOptions, setDeviceOptions] = useState([])
  const [isFilterActive, setIsFilterActive] = useState(false);
  const [firstTimePartnerResourceData, setFirstTimePartnerResourceData] = useState([])
  const [engagedPartnerResourceData, setEngagedPartnerResourceData] = useState([])
  const [selectedOptionsMergedPartnerResource, setSelectedOptionsMergedPartnerResource] = useState([]);
  const [selectedOptionsMergedPartnerResourceEu, setSelectedOptionsMergedPartnerResourceEu] = useState([]);
  const [isFirstUsertableLoading, setIsFirstTableUserLoading] = useState(true);
  const [isVehicleDeviceLoading, setIsVehicleDeviceLoading] = useState(false);
  const [isVehicleDeviceTypeFilterOpen, setIsVehicleDeviceTypeFilterOpen] = useState(false);
  const [selectedOptionsVehicleType, setSelectedOptionsVehicleType] = useState([]);
  const [selectedOptionsDeviceType, setSelectedOptionsDeviceType] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [selectedDevice, setSelectedDevice] = useState(null);


  const handleVehicleDeviceFilterOpen = () => {
    setIsVehicleDeviceTypeFilterOpen(!isVehicleDeviceTypeFilterOpen)
  }

  useEffect(()=>{
    getFTCVehicleData();
  },[props.selectedResourceName, props.fromDate, props.toDate])

  // useImperativeHandle(props.searchRef, () => ({
  //     // handleClearVehicleDeviceFilter,  
  //     getFTCVehicleData
  // }));

  const getFTCVehicleData = () => {
    // getVehicleTypes();
    if(vehicleDeviceCombinationFilterData.length == 0){ 
      setIsVehicleDeviceLoading(true);
    }
    if (props.selectedResourceName.length>0) {
      setVehicleDeviceCombinationFilterData([])
      const filterParameters = {};
            if (props.selectedResourceName.length > 0) {
              filterParameters["sDreambigTitle"] = props.selectedResourceName?.map(opt => opt.value);
            }
            if (props.fromDate && props.toDate) {
              const originalDate = new Date(props.toDate);
              originalDate.setUTCDate(originalDate.getUTCDate() + 1);
              const newDateStr = originalDate.toISOString();
              
              filterParameters.fromDate = dateAdjusted1(props.fromDate);
              filterParameters.toDate = dateAdjusted1(newDateStr);
          }
      api.getLandingPageVehicleData(filterParameters).then((res) => {
        if (res) {
          setVehicleDeviceCombinationFilterData(res.data)
          setIsVehicleDeviceLoading(false)
        }
      })
    }
  }

 
const dateAdjusted1 = (date) => {
    let toDateAdjusted;
    if (date) {
        toDateAdjusted = new Date(date);

        toDateAdjusted = new Date(
            toDateAdjusted.setTime(
                // toDateAdjusted.getTime() + ((6 * 60 * 60 * 1000) - (0.5 * 60 * 60 * 1000)) 
                toDateAdjusted.getTime() + (5.5 * 60 * 60 * 1000)
            )
        );
    }
    return toDateAdjusted;
}

  const getVehicleTypes = () => {
    const filterParameters = { sResourceDisplayName: props.selectedResourceName[0]?.value }
    if (filterParameters) {
      const { tempDreamBigVehicleDeviceCombinationCount } = api.getDreamBigVehicleDeviceCombinationCount(filterParameters)
        .then(({ data }) => {
          if (data) {

            const uniqueVehicle = {};
            const uniqueDevice = {};

            for (let elem of data) {
              const vehicle = elem.vehicle ? elem.vehicle : "Not Provided";
              const device = elem.device ? elem.device : "Not Provided";

              if (uniqueVehicle[vehicle]) {
                uniqueVehicle[vehicle]++;
              } else {
                uniqueVehicle[vehicle] = 1;
              }

              if (uniqueDevice[device]) {
                uniqueDevice[device]++;
              } else {
                uniqueDevice[device] = 1;
              }
            }

            let allUniqueVehicle = Object.keys(uniqueVehicle);
            let allUniqueDevice = Object.keys(uniqueDevice);




            let formatedVehicleOption = allUniqueVehicle.map((val) => {
              return {
                label: val !== "Not Provided" ? val : "Not Provided",
                value: val !== "Not Provided" ? val : null,
              }
            })

            let formatedDeviceOption = allUniqueDevice.map((val) => {
              return {
                label: val !== "Not Provided" ? val : "Not Provided",
                value: val !== "Not Provided" ? val : null,
              }
            })

            let formattedData = data.map((obj) => {
              if (!obj.vehicle) {
                obj.vehicle = "Not Provided"
              }

              if (!obj.device) {
                obj.device = "Not Provided"
              }

              return obj;
            })

            let sortedFormattedData = formattedData.sort((a, b) => {
              const vehicleA = a.vehicle?.toLowerCase() || "";
              const vehicleB = b.vehicle?.toLowerCase() || "";
              return vehicleA.localeCompare(vehicleB);
            })


            setVehicleOptions(formatedVehicleOption);
          } else {
            toast("", {
              autoClose: 5000,
              type: toast.TYPE.ERROR,
            })
          }
        }).catch((error) => {
          if (error.response.data.detail !== "Authentication credentials were not provided.") {
            toast(String(error.response.data.detail), {
              autoClose: 5000,
              type: toast.TYPE.ERROR,
            });
          } else if (error.response.data.message) {
            toast(String(error.response.data.message), {
              autoClose: 5000,
              type: toast.TYPE.ERROR,
            });
          }
        }).finally(() => {
          // setIsFirstTableUserLoading(false);
        })
    }

  }

  useEffect(() => {
    let isMounted = true;
  
    const processDataAndSetRows = () => {
      // getFTCVehicleData(); // Your existing data fetching

      if (!isMounted) return;
  
      // Always ensure we have an array
      const dataArray = Array.isArray(props.landingPageData)
        ? props.landingPageData
        : props.landingPageData
        ? [props.landingPageData]
        : [];
  
      if (dataArray.length === 0) {
        setRowData([]);
        return;
      }
  
      const [field, direction] = sortBy?.split("|") || [];
      const isAsc = direction === "asc";
  
      const getOverallItemCount = (item) => {
        if (!item) return 0;
        if (field === "resourcesAvailed") {
          return (item.subtype_counts || []).reduce(
            (sum, obj) => sum + (Number(obj?.user_count) || 0),
            0
          );
        }
        return Number(item.total_users) || 0;
      };
  
      const sortedData = dataArray
        .filter(Boolean)
        .sort((a, b) => {
          const countA = getOverallItemCount(a);
          const countB = getOverallItemCount(b);
          return isAsc ? countA - countB : countB - countA;
        })
        .map((item) => {
          // Sort subtype_counts within each item
          const sortedSubtypes = [...(item.subtype_counts || [])].sort((a, b) =>
            isAsc
              ? a.user_count - b.user_count
              : b.user_count - a.user_count
          );
  
          return {
            ...item,
            subtype_counts: sortedSubtypes
          };
        });
  
      const groupedData = sortedData.map((item) => ({
        programManager: item.sDreambigTitle,
        ftc: item.total_users || 0,
        partners: [
          {
            partner: item.sDreambigTitle,
            resources: (item.subtype_counts || []).map((src) => ({
              label: src.sResourceSubType,
              count: src.user_count
            }))
          }
        ],
        totalResources: (item.subtype_counts || []).reduce(
          (sum, s) => sum + (Number(s.user_count) || 0),
          0
        )
      }));
  
      if (isMounted) {
        setRowData(groupedData);
        console.log("Final Grouped Data:", groupedData);
      }
    };
  
    processDataAndSetRows();
  
    return () => {
      isMounted = false;
    };
  }, [sortBy, props.landingPageData]);
  
 


  const handleClearVehicleDeviceFilter = () => {
    setSelectedVehicle(null);
    setSelectedDevice(null);
    setIsFilterActive(false);
    setIsVehicleDeviceTypeFilterOpen(false)
    setVehicleDeviceCombinationFilterData([])
    setSelectedOptionsVehicleType([]);
    setSelectedOptionsDeviceType([])

  }

  const handleVehicleDeviceCombinationSearch = async () => {


    setIsVehicleDeviceLoading(true)
    setIsVehicleDeviceTypeFilterOpen(false);

    try {
      setIsFilterActive(true);

      const filterParameters = { sDreambigTitle: props.selectedResourceName[0].value };

      if (selectedOptionsVehicleType.length > 0) {
        filterParameters.vehicle_type = selectedOptionsVehicleType.map(opt => opt.value);
      }


      // const { data } = await api.getVehicleData(filterParameters);
      const { data } = await api.getLandingPageVehicleData(filterParameters);
      if (data) {
        console.log('res:::1',data)
        setVehicleDeviceCombinationFilterData(data);
      } else {
        toast("No data found", {
          autoClose: 5000,
          type: toast.TYPE.ERROR,
        });
      }
    } catch (error) {
      const detail = error?.response?.data?.detail;
      const message = error?.response?.data?.message;
      if (detail && detail !== "Authentication credentials were not provided.") {
        toast(String(detail), { autoClose: 5000, type: toast.TYPE.ERROR });
      } else if (message) {
        toast(String(message), { autoClose: 5000, type: toast.TYPE.ERROR });
      }
    } finally {
      setIsVehicleDeviceLoading(false)
    }

  }

  const handleMultipleVehicleSelect = (selected) => {
    setSelectedOptionsVehicleType(selected)
  }





  useEffect(() => {
    if (props.selectedPartnerName && props.resourceDataSelectedPartner) {
      setResourcesData(props.resourceDataSelectedPartner);
    } else {
      setResourcesData([]);
    }
  }, [props.selectedPartnerName, props.resourceDataSelectedPartner]);


  const hasAnyResource = rowData.some(pm =>
    pm.partners?.some(partner =>
      partner.resources?.length > 0
    )
  );
  return (
    <div className="mb-5">
      {props.selectedResourceName && props.selectedResourceName.length > 0 && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", margin: 10 }}>
            <h3 className="spled-colored-label" style={{ fontSize: "20px", margin: 0 }}>
              User Data for Landing Page
            </h3>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <label style={{ fontWeight: 500 }}>Sort By:</label>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                style={{ padding: "5px 10px", borderRadius: 5 }}
              >
                <option value="">-- Select --</option>
                <option value="resourcesAvailed|asc">Resources Availed (Low to High)</option>
                <option value="resourcesAvailed|desc">Resources Availed (High to Low)</option>
              </select>
            </div>
          </div>
          {!hasAnyResource  ? (
  // 👉 NO DATA: Render combined table with a "No Data Available" message
  <div style={{ height: '50vh', display: 'flex', position: 'relative', borderRadius: '0px', overflow: 'hidden', border: '1px solid #000',borderRight: 'none',   borderRadius: '12px', }}>
    <table style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'center' }}>
      <thead>
        <tr>
          <th style={{ backgroundColor: '#77417f', color: '#fff', padding: '10px' }}>Landing Page</th>
          <th style={{ backgroundColor: '#77417f', color: '#fff', padding: '10px',textAlign:'right' }}>FTCs</th>
          {/* <th style={{ backgroundColor: '#77417f', color: '#fff', padding: '10px' }}>Partner</th> */}
          <th style={{ backgroundColor: '#77417f', color: '#fff', padding: '10px' }}>Resources Availed</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan="4" style={{ padding: '20px', color: '#555' }}>
            No data available
          </td>
        </tr>
      </tbody>
    </table>
  </div>
) 
:

<div style={{ height: '50vh', overflow: 'hidden', border: '1px solid #000', borderRadius: '12px', backgroundColor: '#ececec', position: 'relative' }}>
 {props.isResourceTableLoading && <Spinner className="center" />}
<div style={{ overflowY: 'auto', maxHeight: '45vh' }}>
  <table style={{ borderCollapse: 'collapse', width: '100%', tableLayout: 'fixed' }}>
    <thead style={{ position: 'sticky', top: 0, backgroundColor: '#77417f', color: '#fff', zIndex: 1 }}>
      <tr>
        <th style={{ padding: '8px', width: '400px',backgroundColor: '#77417f' }}>Resource Name</th>
        <th style={{ padding: '8px', width: '100px',backgroundColor: '#77417f',textAlign:'right' }}>FTCs</th>
        {/* <th style={{ padding: '8px', width: '250px',backgroundColor: '#77417f', wordWrap:'break-word', whiteSpace:'normal',overflowWrap: 'break-word', }}>Partner</th> */}
        <th style={{ padding: '8px', width: '300px',backgroundColor: '#77417f' }}>Resources Availed</th>
      </tr>
    </thead>
    <tbody>
      {!hasAnyResource && rowData.length === 0 ? (
        <tr>
          <td colSpan="4" style={{ textAlign: 'center', padding: '20px', color: '#555' }}>No data available</td>
        </tr>
      ) : (
        rowData.map((pm, pmIndex) => {
          const totalResourceRows = pm.partners.reduce((acc, partner) => acc + partner.resources.length, 0);
          let rowIndex = 0;

          return pm.partners.map((partner, partnerIndex) =>
            partner.resources.map((res, resIndex) => {
              const showProgramManager = rowIndex === 0;
              const showPartner = resIndex === 0;

              const row = (
                <tr key={`${pmIndex}-${partnerIndex}-${resIndex}`}>
                  {showProgramManager && (
                    <>
                      <td rowSpan={totalResourceRows} style={{ backgroundColor: '#ececec', border: '1px solid #ccc', padding: '8px', verticalAlign: 'top',width: '400px' }}>
                        {pm.programManager}
                      </td>
                      <td rowSpan={totalResourceRows} style={{ backgroundColor: '#ececec', border: '1px solid #ccc', padding: '8px', verticalAlign: 'top',textAlign:'right',width: '100px' }}>
                        {pm.ftc}
                      </td>
                    </>
                  )}
                  {/* {showPartner && (
                    <td rowSpan={partner.resources.length} style={{ border: '1px solid #ccc', padding: '8px', verticalAlign: 'top',width: '250px', wordWrap:'break-word', whiteSpace:'normal',overflowWrap: 'break-word', }}>
                      {partner.partner}
                    </td>
                  )} */}
                  <td style={{ border: '1px solid #ccc', padding: '8px',width: '300px' }}>{res.label}: {res.count}</td>
                </tr>
              );

              rowIndex++;
              return row;
            })
          );
        })
      )}
    </tbody>
  </table>
</div>

{/* Sticky Footer */}
{rowData.length > 0 && (
  // <div style={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: '#77417f', color: '#fff', padding: '8px', textAlign: 'right' }}>
  //     Total: {rowData.reduce((total, pm) => total + (pm.ftc || 0), 0)}  </div>
  <div style={{ position: 'absolute', bottom: 0, width: '100%', backgroundColor: '#77417f', color: '#fff', padding: '0px', textAlign: 'left' }}>
    <table style={{ width: '100%',border: 'none', tableLayout: 'fixed' }}>
      <tfoot>
        <tr style={{ backgroundColor: '#77417f', color: '#fff' }}>
          <td style={{ width: '200px',border: 'none', backgroundColor: '#77417f', borderRadius: '0px' }}></td>
          <td style={{ width: '100px',border: 'none', backgroundColor: '#77417f' }}></td>
          <td style={{ width: '250px',border: 'none', backgroundColor: '#77417f' }}></td>
          <td style={{ width: '310px',border: 'none', fontWeight: 'bold', backgroundColor: '#77417f', borderRadius: '0px' }}>
          Total: {rowData.reduce((total, pm) => total + (pm.ftc || 0), 0)}          </td>
        </tr>
      </tfoot>
    </table>
  </div>
)}
</div>
}






          <div className="row mt-3 mb-3">
            <div className={`col-12  ${isVehicleDeviceLoading && "set-opacity"}`}>
              {isVehicleDeviceLoading && <Spinner className="center" />}
              <FTULandingPageVehicleData
                selectedResourceName={props.selectedResourceName}
                ftuVehicleQuestionCount={ftuVehicleQuestionCount}
                ftuDeviceCount={ftuDeviceCount}
                vehicleDeviceCombination={vehicleDeviceCombination}
                vehicleOptions={vehicleOptions}
                deviceOptions={deviceOptions}
                vehicleDeviceCombinationFilterData={vehicleDeviceCombinationFilterData}
                isFilterActive={isFilterActive}

                firstTimeData={firstTimePartnerResourceData}
                engagedData={engagedPartnerResourceData}
                selectedOptionsMergedPartnerResource={selectedOptionsMergedPartnerResource}
                setSelectedOptionsMergedPartnerResource={setSelectedOptionsMergedPartnerResource}
                selectedOptionsMergedPartnerResourceEu={selectedOptionsMergedPartnerResourceEu}
                setSelectedOptionsMergedPartnerResourceEu={setSelectedOptionsMergedPartnerResourceEu}
                isFirstUsertableLoading={isFirstUsertableLoading}
                selectedProgramManager={props.selectedProgramManager}

                handleVehicleDeviceFilterOpen={handleVehicleDeviceFilterOpen}
              />
            </div>
          </div>
        </div>
      )}
      <Modal isOpen={isVehicleDeviceTypeFilterOpen}>
        <ModalContent className="dreambig-device-vehicle-filter-modal">
          <div className="modal-header" style={{
            color: '#fff'
          }}>
            <span className="modal-title">Filters</span>
            <img
              alt="close"
              id="Close"
              src={close_modal}
              className="close modal-close"
              onClick={() => setIsVehicleDeviceTypeFilterOpen(false)}
            />
          </div>

          <div className="modal-body">
            <div>
              <div className='mt-0 mb-3 p-2' style={{ backgroundColor: "" }}>
                {
                  <div className="" style={{
                    height: "300px",
                    backgroundColor: "",
                  }}>
                    {/* 1 */}
                    <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                      <div className="col-6 mt-2 spled-container" style={{ backgroundColor: "", zIndex: "6" }}>


                        <ReactMultiSelectCheckboxes
                          options={vehicleOptions}
                          placeholderButtonLabel="Select Vehicle Type"
                          value={selectedOptionsVehicleType}
                          onChange={handleMultipleVehicleSelect}
                        />
                      </div>

                    </div>

                    <div className="row" style={{ padding: "0px 30px", backgroundColor: "" }}>
                      <div className="col-12 mt-5 spled-container mt-6" style={{ backgroundColor: "", display: "flex", justifyContent: "flex-end", gap: "20px" }}>
                        <Button onClick={handleClearVehicleDeviceFilter}>Clear All</Button>

                        <Button onClick={handleVehicleDeviceCombinationSearch}>Search</Button>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default DreamBigProgramManagerLandingPageTable;



